import React from 'react';
import PropTypes from 'prop-types';
import { TABLE_COLUMNS_NAMES } from '../../constants';
import { SimpleTableComponent } from '../../../../components/simple-table';
import { OrdersWaysForm } from '../orders-ways-form';
import { CustomLoader } from '../../../../components/custom-loader';

export const OrdersWaysContent = ({ ordersWaysInfo, isOrdersWaysInfoLoading, isOrdersWaysFormOpen }) => {
	return isOrdersWaysFormOpen ? (
		<OrdersWaysForm />
	) : (
		<>
			{isOrdersWaysInfoLoading ? (
				<CustomLoader />
			) : (
				<>
					<SimpleTableComponent
						rows={ordersWaysInfo}
						isTableDataLoading={isOrdersWaysInfoLoading}
						columns={TABLE_COLUMNS_NAMES}
					/>
				</>
			)}
		</>
	);
};
OrdersWaysContent.propTypes = {
	ordersWaysInfo: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
		}),
	),
	isOrdersWaysInfoLoading: PropTypes.bool.isRequired,
	isOrdersWaysFormOpen: PropTypes.bool.isRequired,
};
